<div class="container">
  <ul class="progressbar">
    <li
      [ngClass]="{ active: currentStep >= 1 && !isDetailsView, 'inactive disabled': currentStep <= 0 || isDetailsView }"
      id="location-update">
      <i
        class="icon-location header-icon"
        [ngClass]="{ 'active-header-icon': currentStep >= 1 && !isDetailsView }"
        (click)="router.navigateByUrl('/jurisdiction')"></i>
      <div class="location-text-box">{{ 'basic-profile.jurisdiction.juri_check' | translate }}</div>
    </li>

    <ng-container *ngIf="!showTechnicalFormFirst">
      <li [ngClass]="{ active: currentStep >= 2, 'inactive disabled': currentStep <= 1 }" id="personal-data-0">
        <i class="icon-info header-icon" [ngClass]="{ 'active-header-icon': currentStep >= 2 }" (click)="navigate('personal-data')"></i>
        <div class="location-text-box">{{ 'basic-profile.jurisdiction.perData' | translate }}</div>
      </li>
      <li [ngClass]="{ active: currentStep >= 3, 'inactive disabled': currentStep <= 2 }" id="tech-data-0">
        <i class="header-icon" [ngClass]="{ 'active-header-icon': currentStep >= 3 }" (click)="navigate('facilities')">
          <span class="icon-technical_data1"></span>
          <span class="icon-technical_data2"></span>
          <span class="icon-technical_data3"></span>
        </i>
        <div class="location-text-box">{{ 'app.navigation.tech_data' | translate | uppercase }}</div>
      </li>
    </ng-container>

    <ng-container *ngIf="showTechnicalFormFirst">
      <li [ngClass]="{ active: currentStep >= 2, 'inactive disabled': currentStep <= 1 }" id="tech-data-1">
        <i class="header-icon" [ngClass]="{ 'active-header-icon': currentStep >= 2 }" (click)="navigate('technical-data')">
          <span class="icon-technical_data1"></span>
          <span class="icon-technical_data2"></span>
          <span class="icon-technical_data3"></span>
        </i>
        <div class="location-text-box">{{ 'app.navigation.tech_data' | translate | uppercase }}</div>
      </li>
      <li
        [ngClass]="{ active: isDetailsView || currentStep >= 3, 'inactive disabled': currentStep <= 2 && !isDetailsView }"
        id="personal-data-1">
        <i
          class="icon-info header-icon"
          [ngClass]="{ 'active-header-icon': isDetailsView || currentStep >= 3 }"
          (click)="navigate('personal-data')"></i>
        <div class="location-text-box">{{ 'basic-profile.jurisdiction.perData' | translate }}</div>
      </li>
    </ng-container>

    <li [ngClass]="{ active: currentStep >= 4 || isDetailsView, 'inactive disabled': currentStep <= 3 && !isDetailsView }" id="upload">
      <i
        class="icon-upload header-icon"
        [ngClass]="{ 'active-header-icon': currentStep >= 4 || isDetailsView }"
        (click)="navigate('documents')"></i>
      <div class="location-text-box">{{ 'app.navigation.doc_upload' | translate | uppercase }}</div>
    </li>
  </ul>
</div>
